
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teste-de-velocidade",
      function () {
        return require("private-next-pages/teste-de-velocidade/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teste-de-velocidade"])
      });
    }
  